export class ImageHistoryFilterModel {
    public userId: string;
    constructor() {
        this.userId = '';
}
}